module.exports = __webpack_public_path__ + "static/media/krx-public-01.9f63a7dc.jpg";